module.exports = __webpack_public_path__ + "static/logo-white-eca7371d7f3e4f96335f1a5a037d4c00.png";